// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CrmUtils from "../../../../../../../../../library/CrmUtils.bs.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CountryContext from "../../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CrmRouteManager from "../../../../../../../to-be-migrated/routing/CrmRouteManager.bs.js";
import * as Accordion$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as DriverRecordsStore from "../../DriverRecordsStore.bs.js";
import * as FilterOrderRequest from "../../../../../../../filter-order/entity/FilterOrderRequest.bs.js";
import * as ViewUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ViewUtils.bs.js";
import * as AccordionAPIWrapper from "../../../../vm-mapper/driver-records/AccordionSections/AccordionAPIWrapper.bs.js";
import * as IncentivesViewMapper from "../../../../vm-mapper/driver-records/IncentivesViewMapper.bs.js";
import * as TicketsRequestMapper from "../../../../../../../ticket-dashboard/app/tickets/entitiy-mapper/TicketsRequestMapper.bs.js";
import * as WalletInfoViewMapper from "../../../../vm-mapper/driver-records/WalletInfoViewMapper.bs.js";
import * as FooterActions$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/FooterActions.bs.js";
import * as OrderHistoryViewMapper from "../../../../vm-mapper/driver-records/OrderHistoryViewMapper.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as PartnerTicketViewMapper from "../../../../vm-mapper/driver-records/PartnerTicketViewMapper.bs.js";
import * as PartnerEarningsViewMapper from "../../../../vm-mapper/driver-records/PartnerEarningsViewMapper.bs.js";
import * as SectionHeaderComponent$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/section-header/SectionHeaderComponent.bs.js";

function getOrderHistoryActions(msisdn, orders, workspace_dispatch) {
  var ordersList = ViewUtils$Catalyst.extractLiveData(orders);
  if (ordersList !== undefined && List.length(ordersList.orders) >= 1) {
    return {
            hd: CrmUtils.getViewMoreButtonProps((function (param) {
                    return Curry._2(workspace_dispatch.addTab, {
                                TAG: /* FilterOrders */40,
                                _0: FilterOrderRequest.toDict({
                                      order_id: undefined,
                                      customer_mobile: undefined,
                                      email: undefined,
                                      msisdn: msisdn,
                                      driver_mobile: undefined,
                                      source: undefined,
                                      order_status: undefined,
                                      geo_region: undefined,
                                      order_type: undefined,
                                      start_datetime: undefined,
                                      end_datetime: undefined,
                                      brand: undefined,
                                      virtual_number: undefined,
                                      is_dn_requested: undefined,
                                      is_business: undefined
                                    })
                              }, false);
                  }), "", undefined, undefined),
            tl: /* [] */0
          };
  } else {
    return /* [] */0;
  }
}

function getPartnerTicketActions(msisdn, tickets, workspace_dispatch) {
  var ticketsList = ViewUtils$Catalyst.extractLiveData(tickets);
  if (ticketsList !== undefined && List.length(ticketsList) >= 1) {
    return {
            hd: CrmUtils.getViewMoreButtonProps((function (param) {
                    return Curry._2(workspace_dispatch.addTab, {
                                TAG: /* Tickets */42,
                                _0: TicketsRequestMapper.DictEncoder.execute({
                                      crn: undefined,
                                      case_number: undefined,
                                      caller_number: undefined,
                                      msisdn: msisdn,
                                      start_datetime: undefined,
                                      end_datetime: undefined,
                                      ticket_status: undefined,
                                      geo_region: undefined,
                                      raised_by: /* Partner */1
                                    })
                              }, false);
                  }), "", undefined, undefined),
            tl: /* [] */0
          };
  } else {
    return /* [] */0;
  }
}

function getWalletInfoActions(msisdn, walletInfo, workspace_dispatch) {
  var walletInfoData = ViewUtils$Catalyst.extractLiveData(walletInfo);
  if (walletInfoData !== undefined && List.length(walletInfoData.transactions) >= 1) {
    return {
            hd: CrmUtils.getViewMoreButtonProps((function (param) {
                    return Curry._2(workspace_dispatch.addTab, {
                                TAG: /* DriverWallet */8,
                                _0: msisdn
                              }, false);
                  }), CrmRouteManager.getRouteFromTab({
                      TAG: /* DriverWallet */8,
                      _0: msisdn
                    }), undefined, undefined),
            tl: /* [] */0
          };
  } else {
    return /* [] */0;
  }
}

function getIncentivesActions(msisdn, incentives, workspace_dispatch) {
  var incentivesList = ViewUtils$Catalyst.extractLiveData(incentives);
  if (incentivesList !== undefined && List.length(incentivesList) >= 1) {
    return {
            hd: CrmUtils.getViewMoreButtonProps((function (param) {
                    return Curry._2(workspace_dispatch.addTab, {
                                TAG: /* DriverIncentivesList */17,
                                _0: msisdn
                              }, false);
                  }), CrmRouteManager.getRouteFromTab({
                      TAG: /* DriverIncentivesList */17,
                      _0: msisdn
                    }), undefined, undefined),
            tl: /* [] */0
          };
  } else {
    return /* [] */0;
  }
}

function getAccordionPanels(msisdn, orders, tickets, weeklyEarnings, walletInfo, incentives, workspace_dispatch, dispatch) {
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  return {
          hd: AccordionTypes$Catalyst.make_props({
                TAG: /* Text */0,
                _0: "Open Tickets"
              }, Caml_option.some(React.createElement(FooterActions$Catalyst.make, {
                        actions: getPartnerTicketActions(msisdn, tickets, workspace_dispatch)
                      })), (function (param) {
                  return AccordionAPIWrapper.fetchUnloadedData(tickets, (function (param) {
                                return DriverRecordsStore.loadTickets(msisdn, dispatch, country);
                              }));
                }), PartnerTicketViewMapper.getView(tickets, workspace_dispatch), undefined),
          tl: {
            hd: AccordionTypes$Catalyst.make_props({
                  TAG: /* Text */0,
                  _0: "Order History"
                }, Caml_option.some(React.createElement(FooterActions$Catalyst.make, {
                          actions: getOrderHistoryActions(msisdn, orders, workspace_dispatch)
                        })), (function (param) {
                    return AccordionAPIWrapper.fetchUnloadedData(orders, (function (param) {
                                  return DriverRecordsStore.loadOrders(msisdn, dispatch, country);
                                }));
                  }), OrderHistoryViewMapper.getView(orders, workspace_dispatch), undefined),
            tl: {
              hd: AccordionTypes$Catalyst.make_props({
                    TAG: /* Text */0,
                    _0: "Wallet Info"
                  }, Caml_option.some(React.createElement(FooterActions$Catalyst.make, {
                            actions: getWalletInfoActions(msisdn, walletInfo, workspace_dispatch)
                          })), (function (param) {
                      return AccordionAPIWrapper.fetchUnloadedData(walletInfo, (function (param) {
                                    return DriverRecordsStore.loadWalletData(msisdn, dispatch, country);
                                  }));
                    }), WalletInfoViewMapper.getView(walletInfo), undefined),
              tl: {
                hd: AccordionTypes$Catalyst.make_props({
                      TAG: /* Text */0,
                      _0: "Partner Earnings"
                    }, undefined, (function (param) {
                        return AccordionAPIWrapper.fetchUnloadedData(weeklyEarnings, (function (param) {
                                      return DriverRecordsStore.loadPartnerEarningsData(msisdn, dispatch, country);
                                    }));
                      }), PartnerEarningsViewMapper.getView(weeklyEarnings, workspace_dispatch), undefined),
                tl: {
                  hd: AccordionTypes$Catalyst.make_props({
                        TAG: /* Text */0,
                        _0: "Incentives"
                      }, Caml_option.some(React.createElement(FooterActions$Catalyst.make, {
                                actions: getIncentivesActions(msisdn, incentives, workspace_dispatch)
                              })), (function (param) {
                          return AccordionAPIWrapper.fetchUnloadedData(incentives, (function (param) {
                                        return DriverRecordsStore.loadIncentives(msisdn, dispatch, country);
                                      }));
                        }), IncentivesViewMapper.getView(incentives), undefined),
                  tl: /* [] */0
                }
              }
            }
          }
        };
}

function ActivityInfoSection(Props) {
  var msisdn = Props.msisdn;
  var orders = Props.orders;
  var tickets = Props.tickets;
  var weeklyEarnings = Props.weeklyEarnings;
  var walletInfo = Props.walletInfo;
  var incentives = Props.incentives;
  var workspace_dispatch = Props.workspace_dispatch;
  var dispatch = Props.dispatch;
  return React.createElement("div", {
              className: "section-container"
            }, React.createElement(SectionHeaderComponent$Catalyst.make, {
                  heading: "Activity Info"
                }), React.createElement(Accordion$Catalyst.make, {
                  panels: getAccordionPanels(msisdn, orders, tickets, weeklyEarnings, walletInfo, incentives, workspace_dispatch, dispatch),
                  className: "accordion-container"
                }));
}

var make = ActivityInfoSection;

export {
  getOrderHistoryActions ,
  getPartnerTicketActions ,
  getWalletInfoActions ,
  getIncentivesActions ,
  getAccordionPanels ,
  make ,
  
}
/* react Not a pure module */
